import register from "~/lib/registerSvelte";
import PriceTable from "../components/PriceTable.svelte"

register({
  PriceTable
})
